import { render } from "./navbar.vue?vue&type=template&id=a109d9b2&scoped=true"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"

import "./navbar.vue?vue&type=style&index=0&id=a109d9b2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/simuam/simuam/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a109d9b2"]])

export default __exports__